// extracted by mini-css-extract-plugin
export var wordContainer = "_ie-0";